<template>
  <layout-basic>
    <TrialPrompts />
    <v-container fluid style="padding-bottom: 0">
      <v-row>
        <v-col md="12">
          <div class="d-flex flex-wrap float-right" style="gap: 10px">
            <v-btn v-if="!userLimit" class="add-course-button" data-tour="add-user" @click.prevent="showCreatePanel" outlined>
              Add User
            </v-btn>
            <v-btn v-else class="add-course-button" data-tour="add-user" disabled @click.prevent="showCreatePanel" outlined>
              Add User
            </v-btn>
            <ImportUsersHR :name="hrPlatformName" v-if="isHRIntegrationEnabled && hrPlatformName != 'SenseHr'" />
            <ImportUsers v-else-if="!isHRIntegrationEnabled || hrPlatformName == 'SenseHr' " />
            <v-btn class="add-course-button" color="primary" @click.prevent="exportCsv('csv')" outlined>
              Export Users
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row v-if="userLimit">
        <v-col md="12">
          <v-alert type="error">You have reached the maximum number of users for your plan</v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="Full-Course-Library-Title"> User Management </v-col>
      </v-row>
      <v-row style="margin-top: 20px">
        <v-col cols="12" sm="4">
          <v-card flat style="background-color: transparent">
            <v-card-actions>
              <v-text-field style="margin-top: 2px !important" class="search-box" placeholder="Search Users By Name Or Email"
                prepend-icon="fa-search" v-model="search" type="text" clearable clear-icon="fa-times"
                @click:clear="resetSearch" @keyup="applySearch"></v-text-field>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card flat style="background-color: transparent">
            <v-card-actions>
              <v-select :items="allGroups" :clearable="true" item-text="name" item-value="id"
                placeholder="Select Groups" multiple small-chips class="groups"
                v-on:change="filterUsersByGroups($event)" attach></v-select>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="sm-mt-20">
        <v-col cols="12" sm="4">
          <v-select v-model="selectedMailOption" :items="mailOption" :clearable="true" item-text="text"
            item-value="value" placeholder="Select Option" persistent-hint
            hint="To send the Welcome Email please select an option to whom you would like to receive. " small-chips
            class="mail-option groups" v-on:change="changeMailOption($event)" attach></v-select>
        </v-col>
        <v-col cols="12" sm="3" v-if="isDormantOption">
          <v-select v-model="dormantDays" :items="dormantDayOptions" item-text="text" item-value="value"
            placeholder="Select inactivity period" persistent-hint
            hint="Users who have not logged in within this period will be emailed." small-chips
            class="mail-option groups" attach></v-select>
        </v-col>
        <v-col cols="12" :sm="isDormantOption ? 4 : 7" class="sm-mt-40">
          <v-btn :disabled="!mailOptionSelected || sendingWelcomeEmail" :loading="sendingWelcomeEmail"
            class="welcome-email-button add-course-button"
            @click.prevent="sendWelcomeEmailToUsers" outlined>
            Send welcome email
          </v-btn>
        </v-col>
      </v-row>
      <v-row style="margin-top: 55px" no-gutters>
        <v-col :cols="12">
          <v-card flat>
            <h3>Current Users: {{ serverItemsLength }} / {{ maxUsers }}</h3>
          </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table v-model="selectedUsersForMail" :headers="computedHeaders" :options.sync="options"
              :server-items-length="serverItemsLength" :items="users" show-select class="mt-3"
              :footer-props="{
                'items-per-page-options': [5, 10, 15, 25 ,50 ,75, 100],
              }"  v-show="!loading" >
              <template v-slot:item.confirmed="{ item }">
                <v-icon v-if="item.confirmed" color="primary">fa-check</v-icon>
                <v-icon v-else color="error">fa-times</v-icon>
              </template>
              <template v-slot:item.total_published_courses="{ item }">
                <span v-if="item.total_published_courses" class="clickable-count"
                  @click.stop="openDialog($event,buildCourseStatus(item),'Courses')">{{ item.total_published_courses
                  }}</span>
                <span v-else>{{ item.total_published_courses }}</span>
              </template>
              <template v-slot:item.total_groups="{ item }">
                <span v-if="item.total_groups" class="clickable-count"
                  @click.stop="openDialog($event,item.groups,'Groups')">{{ item.total_groups }}</span>
                <span v-else>{{ item.total_groups }}</span>
              </template>
              <template v-slot:item.total_channels="{ item }">
                <span v-if="item.total_channels" class="clickable-count"
                  @click.stop="openDialog($event,item.channels,'Playlists')">{{ item.total_channels }}</span>
                <span v-else>{{ item.total_channels }}</span>
              </template>
               <template v-slot:item.site_name="{ item }">
                <span v-if="item.site_name" class="clickable-count"
                  @click.stop="openDialog($event,item.site_name,`${$globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'}`)">{{ item.site_name.length }}</span>
                <span v-else>0</span>
              </template>
              <template v-slot:item.id="{ item }">
                <v-select v-if="screenSize === 'tablet' || screenSize === 'mobile'" v-model="selectedAction"
                  :items="getActionList(item)" item-text="name" item-value="id" placeholder="Select Action"
                  @change="performAction(item)" :item-disabled="action => action.not_allow"></v-select>
                <template v-else>
                <v-tooltip v-if="!item.is_mail_sent" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="primary" class="mr-1" text small
                      :disabled="!!sendingWelcome[item.id]" :loading="!!sendingWelcome[item.id]"
                      @click.prevent="sendWelcomeEmail(item)">
                      <v-icon small>fa-paper-plane</v-icon>
                    </v-btn>
                  </template>
                  <span>Send Welcome Email</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-if="item.id != authenticatedUser" v-slot:activator="{ on }">
                    <v-btn v-on="on" outlined small class="mr-1 action-button action-button-txt"
                      @click.prevent="archiveUser(item.id)">
                      <span>Archive</span>
                    </v-btn>
                  </template>
                  <span>Archive User</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn :id="item.id" v-on="on" outlined small class="mr-1 action-button action-button-txt"
                      @click.prevent="showEditPanel(item.id)">
                      <span>Edit User</span>
                    </v-btn>
                  </template>
                  <span>Edit User</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                      <v-btn
                      v-on="on"
                      outlined
                      small
                      class="mr-1 action-button action-button-txt"
                      :to="'/admin/user-report/'+item.id" 
                      >
                          <span>Report</span>
                      </v-btn>
                  </template>
                  <span>View courses report for this user</span>
                </v-tooltip>
                </template>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <!-- Dialog -->
      <DialogComponent :isOpen="dialog" :dialogTitle="dialogTitle" :dialogData="dialogData" @close="closeDialog" />
    </v-container>
  </layout-basic>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import userAPI from '@/api/user.js';
import companyAPI from '@/api/company.js';
import ImportUsersHR from '@/components/admin/users/ImportUsersHR';
import ImportUsers from '@/components/admin/users/ImportUsers';
import LayoutBasic from '@/layouts/Dashboard';
import TrialPrompts from '@/components/authenticated/welcome/TrialPrompts';
import EditUser from '@/components/admin/users/Edit';
import CreateUser from '@/components/admin/users/Create';
import ViewDetails from '@/components/admin/users/View';
import DialogComponent from '@/components/Dialog';
import { screensize } from '../../utils/screensize';
import {
  WELCOME_QUEUED_MESSAGE,
  persistentToast,
  welcomeEmailErrorMessage,
  readBulkWelcomeResult,
  bulkQueuedMessage,
  describeSkipped,
} from '@/utils/welcomeEmail';

// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
  name: 'UsersAdmin',
  components: {
    LayoutBasic,
    TrialPrompts,
    ImportUsers,
    ImportUsersHR,
    DialogComponent
  },
  beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);
    this.screenSize = null;
  },
  data() {
    return {
      headers: [
        { text: 'First Name', value: 'first_name' },
        { text: 'Surname', value: 'last_name' },
        { text: 'Email', value: 'email' },
        { text: 'Role Access', value: 'role_name'},
        { text: 'Last Login', value: 'last_login', sortable: false },
        { text: 'Courses', value: 'total_published_courses', sortable: false },
        { text: 'Groups', value: 'total_groups', sortable: false },
        { text: 'Playlists', value: 'total_channels', sortable: false },
        { text: '', value: 'id', align: 'end', sortable: false },
      ],
      users: [],
      search: '',
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
      enableMail: '',
      confirmArchive: 'Are you sure you wish to archive this user?',
      opens: 'center',
      isClearButtonVisible: false,
      allGroups: [],
      filterGroups: '',
      mailOption: [
        { text: 'Send Welcome Email to all users', value: 1 },
        {
          text: 'Send Welcome Email to all new or outstanding users',
          value: 2,
        },
        { text: 'Send Welcome Email to selected users only', value: 3 },
        { text: 'Send Welcome Email to never logged in users', value: 4},
        { text: 'Send Welcome Email to users not logged in recently', value: 5}
      ],
      dormantDays: 7,
      dormantDayOptions: [
        { text: 'Not logged in for 7+ days', value: 7 },
        { text: 'Not logged in for 14+ days', value: 14 },
        { text: 'Not logged in for 30+ days', value: 30 },
        { text: 'Not logged in for 90+ days', value: 90 },
      ],
      sendingWelcomeEmail: false,
      // row ids with a single welcome email request in flight
      sendingWelcome: {},
      mailOptionSelected: false,
      selectedMailOption: null,
      selectedUsersForMail: [],
      dormantDaysMissingMessage:
        'Please choose how long a user must have been inactive.',
      noRecipientsMessage:
        'No users match that option, so no welcome emails have been sent.',
      countUnavailableMessage:
        'We could not confirm how many people this will email. They will each be sent a link to set their password. Continue?',
      warningMessage: 'Please select users to send a welcome email.',
      errorMessage: 'Oops, something went wrong!',
      archivedUserMessage:
        'You cannot archive this company admin as they were created by a partner.',
      updateRoleErrorMessage:
        'You cannot change role of admin User as they were created by a partner.',
      timer: null,
      isHRIntegrationEnabled: false,
      hrPlatformName: '',
      locations: [],
      dialog: false,
      dialogTitle : '',
      dialogData: [],
      selectedAction: null,
      screenSize: currentScreenSize,
    };
  },
  computed: {
    computedHeaders() {
      let headers = [...this.headers];
      if (this.locations.length) {
        headers.splice(8, 0, { text: `${this.$globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'}`, value: 'site_name', sortable: false });
      }
      return headers;
    },
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    maxUsers: function () {
      return this.$store.getters.maxUsers;
    },
    userLimit: function () {
      return this.serverItemsLength >= this.maxUsers ? true : false;
    },
    authenticatedUser: function () {
      return this.$store.getters.user.id;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    isDormantOption: function () {
      return this.selectedMailOption == 5;
    },
  },
  mounted() {
    EventBus.$off('USERS_UPDATED');
    this.setEventBus();
    this.getCompany();
    this.getCompanySites();
    //this.$vuetify.theme.themes.light.grass = '#1976D2';
  },
  watch: {
    options: {
      handler() {
        this.getUsers();
      },
      deep: true,
    },
  },
  methods: {
    getUsers() {
      this.loading = true;
      userAPI.getClients(this.params, this.searchParams).then((resp) => {
        this.users = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      }).catch(() => {
        // never leave the table stuck on the loading spinner if the request fails
        this.loading = false;
      });
    },
    resetSearch() {
      this.search = '';
      this.options.page = 1;
      this.createSearchParams();
    },
    setEventBus() {
      EventBus.$on('USERS_UPDATED', (payload) => {
        // if(payload)
        //   this.params = payload;
        
        this.getUsers();
      });
      EventBus.$on('USERS_ADDED', (payload) => {
        // this.params = payload;
        this.getUsers();
      });
    },
    applySearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.options.page = 1;
        this.createSearchParams();
      }, 1000);
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditUser,
        props: {
          id: id,
          params: this.params,
          locations: this.locations
        },
        openOn: 'right',
      });
    },
    showDetailsPanel(id) {
      this.$showPanel({
        component: ViewDetails,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    showCreatePanel() {
      this.$showPanel({
        component: CreateUser,
        props: {
          params: this.params,
          locations: this.locations
        },
        openOn: 'right',
      });
    },
    enableDisableEmail(type) {
      this.loading = true;
      userAPI.enableDisableEmail(type).then((resp) => {
        this.enableMail = resp.data.data.enable_mail;
        this.loading = false;
      });
    },
    getCompany() {
      companyAPI
        .getCompanyById(
          this.$store.getters.user.company.data.id,
          '?include=groups'
        )
        .then((resp) => {
          this.enableMail = resp.data.data.enable_mail;
          this.allGroups = resp.data.data.groups.data;
          this.isHRIntegrationEnabled = resp.data.data.hr_config;
          this.hrPlatformName = resp.data.data.hr_platform;
        });
    },
    sendWelcomeEmail(item) {
      // One request per row at a time: a second click while the first was
      // still in flight queued a second email with a new link.
      if (!item || this.sendingWelcome[item.id]) {
        return;
      }
      this.$set(this.sendingWelcome, item.id, true);
      userAPI.sendWelcomeEmail(item.id).then(() => {
        this.$delete(this.sendingWelcome, item.id);
        // Hide the send icon now. Hub queues the email and only marks the user
        // as sent once it has gone out, so reloading the list here brought the
        // icon straight back and admins clicked it again.
        this.$set(item, 'is_mail_sent', 1);
        this.$snotify.success(WELCOME_QUEUED_MESSAGE);
        setTimeout(() => {
          this.$gf.removeBackdrop();
        }, 300);
      }).catch((err) => {
        this.$delete(this.sendingWelcome, item.id);
        // stays on screen: it usually says why this person cannot be emailed and what to do
        this.$snotify.error(welcomeEmailErrorMessage(err), persistentToast());
        setTimeout(() => {
          this.$gf.removeBackdrop();
        }, 300);
      });
    },
    archiveUser(id) {
      this.$snotify.confirm(this.confirmArchive, {
        backdrop: 0.3,
        buttons: [
          {
            text: 'Cancel',
            className: 'toast-cancel-button',
          },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processArchiveUser(toast, id),
          },
        ],
      });
    },
    processArchiveUser(toast, id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      userAPI.archiveUser(id).then((resp) => {
        if (resp.status == 204) {
          this.$snotify.error(this.archivedUserMessage);
        } else {
          this.getUsers();
        }
        this.loading = false;
      });
    },
    filterUsersByGroups(data) {
      this.filterGroups = data.toString();
      this.createSearchParams();
    },
    createSearchParams() {
      this.searchParams = '';
      this.searchParams = this.params;
      if (this.search) {
        this.searchParams +=
          '&search=first_name:' + this.search + ';last_name:' + this.search+ ';email:' + this.search;
      }
      if (this.filterGroups) {
        this.searchParams += '&groups=' + this.filterGroups;
      }
      this.getUsers();
    },
    changeMailOption(option) {
      this.selectedMailOption = option;
      if (option) {
        this.mailOptionSelected = true;
      } else {
        this.mailOptionSelected = false;
        this.dormantDays = 7;
      }
    },
    // only the dormant option carries a threshold; every other option must send undefined
    dormantDaysForRequest() {
      return this.selectedMailOption == 5 ? this.dormantDays : undefined;
    },
    // tolerate a bare {count} body or the usual {data:{count}} envelope
    resolveRecipientCount(resp) {
      const body = resp && resp.data ? resp.data : {};
      let raw = body.count;
      if (raw === undefined && body.data) {
        raw = body.data.count;
      }
      if (raw === undefined || raw === null || raw === '') {
        return null;
      }
      const count = Number(raw);
      return isNaN(count) ? null : count;
    },
    sendWelcomeEmailToUsers() {
      // guard against a second click while a count lookup or a send is already in flight
      if (this.sendingWelcomeEmail) {
        return true;
      }
      if (
        this.selectedMailOption == 3 &&
        this.processSelectedUsers().length == 0
      ) {
        this.$snotify.error(this.warningMessage);
        return true;
      }
      if (this.selectedMailOption == 5 && !this.dormantDays) {
        this.$snotify.error(this.dormantDaysMissingMessage);
        return true;
      }
      // Hold the in-flight flag from HERE until the confirmation is resolved.
      // Clearing it as soon as the count returned left the Send button live
      // while the confirm toast was open, so a second click opened a second
      // toast and accepting both fired the whole blast twice.
      this.sendingWelcomeEmail = true;
      // option 3 is a hand-picked list, so the count is already known here and needs no lookup
      if (this.selectedMailOption == 3) {
        this.confirmWelcomeEmailSend(this.processSelectedUsers().length);
        return true;
      }
      userAPI
        .getWelcomeEmailRecipientCount(
          this.selectedMailOption,
          this.dormantDaysForRequest()
        )
        .then((resp) => {
          this.confirmWelcomeEmailSend(this.resolveRecipientCount(resp));
        })
        .catch(() => {
          // the preview is a safety net, not a gate: let them proceed but flag the number as unconfirmed
          this.confirmWelcomeEmailSend(null);
        });
      return true;
    },
    confirmWelcomeEmailSend(count) {
      if (count === 0) {
        // nobody matches: release the guard, there is nothing to confirm
        this.sendingWelcomeEmail = false;
        this.$snotify.warning(this.noRecipientsMessage);
        return;
      }
      let message = this.countUnavailableMessage;
      if (count !== null) {
        message =
          'This will email ' +
          count +
          (count == 1 ? ' person' : ' people') +
          ' a link to set their password. Continue?';
      }
      this.$snotify.confirm(message, {
        backdrop: 0.3,
        buttons: [
          {
            text: 'Cancel',
            className: 'toast-cancel-button',
            action: (toast) => {
              // release the guard so the admin can start again
              this.sendingWelcomeEmail = false;
              this.$snotify.remove(toast.id);
              setTimeout(() => {
                this.$gf.removeBackdrop();
              }, 300);
            },
          },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => {
              // hand the guard over: processSendWelcomeEmailToUsers re-arms it
              // immediately and owns clearing it when the request settles.
              this.sendingWelcomeEmail = false;
              this.processSendWelcomeEmailToUsers(toast);
            },
          },
        ],
      });
    },
    processSendWelcomeEmailToUsers(toast) {
      this.$snotify.remove(toast.id);
      if (this.sendingWelcomeEmail) {
        return;
      }
      this.sendingWelcomeEmail = true;
      this.loading = true;
      userAPI
        .sendWelcomeEmailToUsers(
          this.selectedMailOption,
          this.processSelectedUsers(),
          this.dormantDaysForRequest()
        )
        .then((resp) => {
          // queued and skipped are optional: an API without them gets the old message
          const result = readBulkWelcomeResult(resp);
          const skippedWarning = describeSkipped(result.skipped);
          if (result.queued !== 0) {
            this.$snotify.success(bulkQueuedMessage(result.queued));
          } else if (!skippedWarning) {
            this.$snotify.warning(this.noRecipientsMessage);
          }
          // stays on screen so the admin can note who was left out and why
          if (skippedWarning) {
            this.$snotify.warning(skippedWarning, persistentToast());
          }
          this.loading = false;
          this.sendingWelcomeEmail = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
          this.selectedUsersForMail = [];
          this.changeMailOption(null);
          this.getUsers();
        })
        .catch((err) => {
          this.$snotify.error(
            welcomeEmailErrorMessage(err, this.errorMessage, { bulk: true }),
            persistentToast()
          );
          this.loading = false;
          this.sendingWelcomeEmail = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    processSelectedUsers() {
      let members = [];
      this.selectedUsersForMail.forEach(function (x) {
        members.push(x.id);
      });
      return members;
    },
    exportCsv(type) {
      this.loading = true;
      let paramsSearched = '';
      if (this.search) {
        paramsSearched +=
          '&search=first_name:' + this.search + ';last_name:' + this.search+ ';email:' + this.search;
      }
      if (this.filterGroups) {
        paramsSearched += '&groups=' + this.filterGroups;
      }
      userAPI
        .exportUserCSV(
          '?limit=0' + paramsSearched,
          '&withArchive=1&skipPagination=true',
          '&type=' + type
        )
        .then((resp) => {
          window.open(resp.data);
          this.loading = false;
        });
    },
    getCompanySites() {
        companyAPI.getCompanySites().then(response => {
            this.locations = response.data.data;
        });
    },
    buildCourseStatus(user) {
      const completed = user.completed_courses || [];
      const inprogress = user.inprogress_courses || [];
      return (user.published_courses || []).map(name => ({
        name,
        state: completed.includes(name) ? 3 : inprogress.includes(name) ? 2 : 1
      }));
    },
    openDialog(event, data, title) {
      this.dialogTitle = title;
      this.dialogData = data;
      this.dialog = true;
      document.getElementById('improve').style.pointerEvents = 'none';
      document.getElementById('navbar-collapse').style.pointerEvents = 'none';
    },
    closeDialog() {
      document.getElementById('improve').style.pointerEvents = 'unset';
      document.getElementById('navbar-collapse').style.pointerEvents = 'unset';
      this.dialog = false;
    },
    getActionList(item) {
      let actions = [
        {
          name: 'Send Welcome Email',
          action: () => this.sendWelcomeEmail(item),
          not_allow: !!item.is_mail_sent || !!this.sendingWelcome[item.id]
        },
        { name: 'Archive', action: () => this.archiveUser(item.id), not_allow: item.id == this.authenticatedUser },
        {
          name: 'Edit User',
          action: () => this.showEditPanel(item.id)
        },
        {
          name: 'Report',
          action: () => this.$router.push(`/admin/user-report/${item.id}`)
        },
      ];

      return actions;
    },
    performAction(item) {
      const selectedOption = this.getActionList(item).find(
        (option) => option.name === this.selectedAction
      );
      if (selectedOption) {
        selectedOption.action();
      }
      setTimeout(() => {
        this.selectedAction = null;
      }, 0);
    },
     // Method to handle screen size changes
    handleResize() {
      this.screenSize = getCurrentScreenSize();
    },    
  },
};
</script>